import { useEffect, useState } from 'react';
import { client, initStatsig } from './StatsigClient';

export default function useStatsigHelper(props) {
  if (!props || Object.keys(props).length == 0) {
    return {};
  }

  const { experimentId, controlVariation, treatmentVariations = [], ...otherProps } = props;

  if (!experimentId) {
    return otherProps;
  }

  const [componentProps, setComponentProps] = useState(controlVariation);

  const resolve = () => {
    if (!client) {
      console.warn('[useStatsigHelper] no client instance yet');
      return;
    }

    const exp = client.getExperiment(experimentId);

    const variant = exp.groupName || 'control';

    let cp = controlVariation;
    if (!variant.toLowerCase().includes('control')) {
      if (treatmentVariations.length === 1) {
        cp = treatmentVariations[0];
      } else {
        const idx = parseInt(variant.split('-')[1], 10) - 1;
        cp = treatmentVariations[idx] ?? controlVariation;
      }
    }
    setComponentProps(cp);
  };

  useEffect(() => {
    initStatsig(resolve).then(() => {
      resolve();
    });

    const handler = () => {
      resolve();
    };

    client?.on('values_updated', handler);
    return () => {
      client?.off('values_updated', handler);
    };
  }, [experimentId]);

  return componentProps;
}
